import React from 'react';

const Hero = ({ onEnter }) => {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-off-black">
      {/* Full Screen Artwork */}
      <div className="absolute inset-0">
        <img
          src="https://images.squarespace-cdn.com/content/v1/658192afd353ab5f2fad5a64/f61130ce-225f-4a3a-82ef-bb8cd8995410/The+Bath.jpg"
          alt="The Bath"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-off-black/40 via-transparent to-off-black/60"></div>
      </div>

      {/* Centered Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 sm:px-6">
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-serif text-soft-ivory mb-6 sm:mb-8 tracking-tight text-center leading-tight">
          Leigh Witherell
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-serif text-soft-ivory/90 mb-10 sm:mb-12 md:mb-16 tracking-wide text-center max-w-3xl leading-relaxed">
          Paintings about what people don't say.
        </p>

        <button
          onClick={onEnter}
          className="text-soft-ivory border border-soft-ivory/30 px-6 sm:px-8 py-3 text-xs sm:text-sm tracking-widest uppercase hover:bg-soft-ivory/10 transition-all duration-500"
        >
          View Works
        </button>
      </div>
    </section>
  );
};

export default Hero;
